module.exports = __webpack_public_path__ + "img/584c258.jpg";